export default {
    tagged: '2.0.7-a685f67',
    version: '2.0.7',
    revision: 'a685f67',
};
//# sourceMappingURL=version.js.map